"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderInput = SliderInput;
var _react = _interopRequireDefault(require("react"));
var SliderPrimitive = _interopRequireWildcard(require("@radix-ui/react-slider"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function SliderInput(_ref) {
  var onChange = _ref.onChange,
    disabled = _ref.disabled,
    colorValue = _ref.colorValue,
    value = _ref.value,
    min = _ref.min,
    max = _ref.max,
    id = _ref.id,
    trackStyle = _ref.trackStyle;
  var rootProps = {
    id: id,
    name: id,
    onValueChange: function onValueChange(value) {
      return onChange(value[0]);
    },
    value: [value],
    min: min,
    max: max,
    disabled: disabled,
    className: 'relative flex h12 w-full round-full',
    style: {
      cursor: disabled ? 'default' : 'pointer',
      alignItems: 'center',
      touchAction: 'none'
    },
    'data-testid': "".concat(id, "-slider")
  };
  if (disabled) {
    rootProps.className = "".concat(rootProps.className, " opacity50");
  }
  return /*#__PURE__*/_react["default"].createElement(SliderPrimitive.Root, rootProps, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute w-full h3 bg-tile"
  }), /*#__PURE__*/_react["default"].createElement(SliderPrimitive.Track, {
    style: _objectSpread({}, trackStyle),
    className: "h3 relative flex-child-grow round-full"
  }), /*#__PURE__*/_react["default"].createElement(SliderPrimitive.Thumb, {
    className: "w12 h12 round-full block border border--white shadow-darken10",
    style: {
      cursor: disabled ? 'default' : 'ew-resize',
      backgroundColor: colorValue
    }
  }));
}